const OK = 0
const DOUBT = 1
const ERROR = 2

export default {OK, DOUBT, ERROR}



// WEBPACK FOOTER //
// ./src/lib/ChatResponseTypes.js